import { QueryClient } from '@tanstack/react-query';

// Retry only failures that can plausibly succeed on a second attempt: server-side 5xx
// and transport-level errors (network drops, CORS blocks, timeouts — fetch surfaces
// these as TypeError / our UnifiedApiNetworkError). Deterministic 4xx responses are
// final; retrying them just triples the failure latency and request volume.
// Duck-typed on purpose: importing the unified client here would be circular.
const isTransientError = (error: unknown) => {
  const status = (error as { status?: unknown })?.status;
  if (typeof status === 'number') return status >= 500;
  const name = (error as Error)?.name;
  return name === 'UnifiedApiNetworkError' || name === 'TypeError' || name === 'TimeoutError';
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      throwOnError: true,
      staleTime: 1000 * 60 * 5,
      retry: (failureCount, error) => failureCount < 3 && isTransientError(error),
    },
    mutations: {
      throwOnError: true,
    },
  },
});

export * from './sb-helpers';
export * from './fetcher';
export * from './server';
export * from './validators';
export * from './unified';
export * from './tracing';
export { AppError } from './AppError';
